module.exports = __webpack_public_path__ + "static/media/banner.7ac5b290.png";